import { Translate } from "@/app/application/Translate";
import { Box } from "@mui/material";

export const TrainingCoursesTourSteps = [
	{
		selector: '[data-tour="training-page"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingCourses.Welcome">
					Welcome to Training Courses. Manage course folders, create new
					courses, and view upcoming or overdue sessions.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-tabs"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingDashboard.Tabs">
					Use these tabs to switch between Dashboard, Courses, Drills, Archive,
					and Planner. Dashboard shows the overview here; Courses and Drills
					show detailed session management; Archive lists completed sessions;
					Planner helps schedule training.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-courses-folders"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingCourses.Folders">
					Folders and courses — search folders, courses, and links. Use Actions
					to create a new folder, link, or course. Expand folders to browse
					courses; click a course to view its details and sessions in the right
					panel.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-courses-right"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingCourses.Right">
					Course content — when no course is selected, this panel shows upcoming
					and overdue sessions. Select a course from the left to see its
					details, sessions, and files. Click a session to view or edit it.
				</Translate>
			</Box>
		),
	},
];
